@if (!loading) {
  <div class="contest-lessons__wrapper">
    @if (canCompete) {
      <app-contest-header [contest]="contest"></app-contest-header>
    }
    <div class="contest-lessons__content"
      [ngClass]="{'contest-lessons__content--border-radius': !canCompete}">
      @if (selectedLesson) {
        <button class="contest-lessons__back"
          mat-button
          type="button"
          (click)="backToLessons()">
          {{ 'generic.back' | translate }}
        </button>
        <h2 class="contest-lessons__title">{{ selectedLesson.get('metadatas')?.title }}</h2>
        <ul class="contest-lessons__list">
          @for (subLesson of subLessons; track subLesson.id) {
            <li class="contest-lessons__item">
              <app-activty-card class="contest-lessons__card"
                [isActivitiesIsDone]="true"
                [disabled]="!hasActivities(subLesson)"
                [title]="subLesson.get('metadatas')?.title"
                [image]="getSubLessonTypeImage(subLesson)"
                [subLesson]="subLesson"
                [i]="0"
                (playEvent)="playEvent($event)">
              </app-activty-card>
            </li>
          } @empty {
            <li class="contest-lessons__empty">{{ 'generic.no_results' | translate }}</li>
          }
        </ul>
      } @else {
        <div class="contest-lessons__cards">
          @for (dataCard of dataCards; track dataCard.resource.id) {
            <app-card [dataCard]="dataCard"></app-card>
          } @empty {
            <p class="contest-lessons__empty">{{ 'generic.no_results' | translate }}</p>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <div class="contest-lessons__spinner-wrapper">
    <mat-spinner></mat-spinner>
  </div>
}
